import {makeAdUrl} from '@frontend/helpers'
import type {
    AdPreviewDataForGrid,
    AdPreviewDataForList,
} from '@frontend/modules/public/ads/AdsModuleTypes'
import {HorizontalSwiper} from '@shared/components/TouchHandler/HorizontalSwiper'
import clsx from 'clsx'
import {useState} from 'react'
import {Link} from 'react-router-dom'
import {useEventCallback} from 'swayok-react-mdb-ui-kit/helpers/useEventCallback'
import {AnalyticsEventReporter} from '../../../../../helpers/AnalyticsEventReporter'

interface AdPhotosSwiperProps {
    ad: AdPreviewDataForGrid | AdPreviewDataForList
    noShadow?: boolean
}

const maxImagesToShow: number = 5

// Список фотографий объявления для предпросмотра в списке объявлений.
export function AdPreviewPhotosSwiper(props: AdPhotosSwiperProps) {

    const {
        ad,
        noShadow = true,
    } = props

    // Индекс отображаемой фотографии.
    const [
        photoIndex,
        setPhotoIndex,
    ] = useState<number>(0)

    const images = ad.photos.slice(0, maxImagesToShow + 1)

    // Показать следующую картинку.
    const nextImage = useEventCallback(() => {
        setPhotoIndex((photoIndex + 1) % images.length)
    })

    // Показать предыдущую картинку.
    const prevImage = useEventCallback(() => {
        setPhotoIndex(
            photoIndex === 0
                ? images.length - 1
                : photoIndex - 1
        )
    })

    // Обработчик нажатия на ссылку объявления.
    const onClick = useEventCallback(() => {
        AnalyticsEventReporter.clickOnAdFromList(ad)
    })

    return (
        <HorizontalSwiper
            onNext={nextImage}
            onPrevious={prevImage}
            className="offered-item-card-images-swiper position-relative"
        >
            <Link
                to={makeAdUrl(ad.slugWithId, ad.categorySlugWithId)}
                style={
                    images.length
                        ? {backgroundImage: `url("${images[0]}")`}
                        : undefined
                }
                target="_blank"
                rel="noreferrer"
                className={clsx(
                    'offered-item-card-image rounded-6',
                    noShadow ? '' : 'shadow-3',
                    'position-relative'
                )}
                onClick={onClick}
            >
                {images.length > 1 && (
                    <>
                        {/* Отображение текущей выбранной картинки. */}
                        <span
                            className="offered-item-card-alternative-image rounded-6"
                            style={
                                images[photoIndex]
                                    ? {backgroundImage: `url("${images[photoIndex]}")`}
                                    : undefined
                            }
                        />
                        {/* Перелистывание картинок при движении курсора по блоку объявления. */}
                        <span className="offered-item-card-photo-changer flex-container-row">
                            {images.map((photo, index) => (
                                <span
                                    key={photo}
                                    className="flex-1"
                                    onMouseEnter={() => setPhotoIndex(index)}
                                />
                            ))}
                        </span>
                    </>
                )}
            </Link>
            {images.length > 1 && (
                <div className="offered-item-card-images-nav">
                    {images.map((photo, index) => (
                        <div
                            key={photo}
                            className={index === photoIndex ? 'active' : ''}
                        />
                    ))}
                </div>
            )}
        </HorizontalSwiper>
    )
}
